import React, { Component } from 'react'

import { withRouter } from 'react-router-dom';
import Auth from '../../Auth'

const auth = new Auth();


class Logout extends Component {
    constructor(props) {
        super(props);
        auth.signOut();
        props.history.push("/");
    }


    render() {
        return (
            <div></div>
            )
    }
}

export default withRouter(Logout)